import { render, staticRenderFns } from "./TeamReview.vue?vue&type=template&id=9353949e&scoped=true"
import script from "./TeamReview.vue?vue&type=script&lang=js"
export * from "./TeamReview.vue?vue&type=script&lang=js"
import style0 from "./TeamReview.vue?vue&type=style&index=0&id=9353949e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9353949e",
  null
  
)

export default component.exports